import React from 'react';
import classNames from 'classnames';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
export var CropSizeList = function CropSizeList(props) {
  var datasource = props.datasource,
    value = props.value,
    onValueChange = props.onValueChange,
    style = props.style;
  var cls = usePrefixCls('crop-list');
  return React.createElement("div", {
    className: cls,
    style: style
  }, datasource === null || datasource === void 0 ? void 0 : datasource.map(function (_ref) {
    var label = _ref.label,
      itemValue = _ref.value,
      disabled = _ref.disabled;
    return React.createElement("span", {
      className: classNames("".concat(cls, "-item"), value === itemValue && "".concat(cls, "-item-active"), disabled && "".concat(cls, "-item-disabled")),
      key: String(itemValue),
      onClick: function onClick() {
        return disabled ? null : onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(itemValue);
      }
    }, label);
  }));
};